import React from 'react';

const SortIcon = ({ column, sortColumn, sortDirection }) => {
  if (sortColumn !== column) {
    return <span style={{ opacity: 0.3, marginLeft: '4px' }}>&#8597;</span>;
  }
  return <span style={{ marginLeft: '4px' }}>{sortDirection === 'asc' ? '↑' : '↓'}</span>;
};

export default SortIcon;
